import { updateOrdersSearchNext } from 'entities/orders/model/ordersSlice';
import { selectOrdersSearchNext } from 'entities/orders/model/selectors';
import { FC } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { ContoledInputSearch } from 'shared/ui/inputSearch/controledInputSearch';

interface SearchProps {
    hide?: boolean;
}

export const SearchOrders: FC<SearchProps> = () => {
    const ordersSearch = useAppSelector(selectOrdersSearchNext)
    const dispatch = useAppDispatch();

    const handleSearch = (searchValue: string) => {
        dispatch(updateOrdersSearchNext(searchValue))
    };

    return (
        <>
            <ContoledInputSearch onChange={handleSearch} value={ordersSearch} />
        </>
    );
};
